export enum AgentType {
  NORMAL = 'NORMAL',
  NOVIBET = 'NOVIBET'
}